<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div class="container-fulid text-center overflow-hidden">
  <div class="row justify-content-center">
    <div class="col-8">
      <h1 class="lifedi-color">
        จัดการผู้ใช้งาน
      </h1>
    </div>
  </div>
  <div class="row justify-content-center">
    <ul>
      <li><a [class.text-danger]="tableName === 'user'" (click)="manageTable('user')">ผู้ใช้งาน</a></li>
      <li><a [class.text-danger]="tableName === 'teacher'" (click)="manageTable('teacher')">อาจารย์</a></li>
      <li><a [class.text-danger]="tableName === 'psychologist'" (click)="manageTable('psychologist')">นักจิตวิทยา</a>
      </li>
      <li><a [class.text-danger]="tableName === 'admin'" (click)="manageTable('admin')">แอดมิน</a></li>

    </ul>
  </div>
  <div class="row d-flex pb-4 justify-content-center">
    <input type="text" class="form-control search" placeholder="ค้นหาอีเมล" name="searchEmail" [(ngModel)]="search"
      (keyup)="searching()">
    <lifedi-btn *ngIf="tableName !== 'user'" lable="เพิ่มบัญชี"
      customStyle="position: absolute; right: 3%; margin-top: 0px; padding: 0 25px; background: #005C3D; color: #FFFFFF"
      (click)="addAccount(tableName)">
    </lifedi-btn>
  </div>
  <!-- <lifedi-table *ngIf="accounts" [columnsData]="column" [rowsData]="accounts"></lifedi-table> -->

  <table class="table table-striped" style="width: 95%; margin: 0 auto;">
    <thead>
      <tr class="d-flex">
        <th scope="col" *ngFor="let col of column" [class]="col.style">{{col.header}}</th>
      </tr>
    </thead>

    <!-- not search -->
    <tbody *ngIf="!isSearch">
      <tr class="d-flex" *ngFor="let row of rows" (ngModelChange)="refresh()">
        <td scope="row" *ngFor="let col of column; let last = last;" [class]="col.style">
          <span *ngIf="!last">
            {{ row[col.field] }}
          </span>
          <span *ngIf="last">
            <a (click)="seeDetail(row, col.role)" style="cursor: pointer;">
              <img src="../../../../assets/employee.png" style="width: 20px;">
            </a>
          </span>
        </td>
      </tr>
    </tbody>

    <!-- search -->
    <tbody *ngIf="isSearch">
      <tr class="d-flex" *ngFor="let row of rows" (ngModelChange)="refreshSearch()">
        <td scope="row" *ngFor="let col of column; let last = last;" [class]="col.style">
          <span *ngIf="!last">
            {{ row[col.field] }}
          </span>
          <span *ngIf="last">
            <!-- <a (click)="edit(row, col.role)"> -->
            <a (click)="seeDetail(row, col.role)" style="cursor: pointer;">
              <img src="../../../../assets/employee.png" style="width: 20px;">
            </a>
          </span>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="d-flex justify-content-center p-2">
    <ngb-pagination *ngIf="!isSearch" [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize"
      (pageChange)="refresh()">
    </ngb-pagination>
    <ngb-pagination *ngIf="isSearch" [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize"
      (pageChange)="refreshSearch()">
    </ngb-pagination>
  </div>
  <select class="custom-select" style="width: auto; float: right; margin-right: 30px;" [(ngModel)]="pageSize"
    (ngModelChange)="refresh()">
    <option [ngValue]="10">10 items per page</option>
    <option [ngValue]="15">15 items per page</option>
    <option [ngValue]="20">20 items per page</option>
  </select>
</div>
